import { getGeoLocationMetaData } from 'selectors/user/cookie'
import { getAvailableCountries } from 'selectors/shared/locale'
import { User } from 'types/User'
import { Shared } from 'types/Shared'

type State = {
  user: User
  shared: Shared
}

type PageTitles = {
  pageTitle?: string
  ogPageTitle?: string
}

// Appends the user's resolved country name to non-US titles.
const localizeTitle = (title: string, initialState: State): string => {
  const geoLocationMetaData = getGeoLocationMetaData(initialState)
  const countries = getAvailableCountries(initialState)
  const { storeLocale: currentStoreLocale } = geoLocationMetaData

  const currentIso2CountryCode = (currentStoreLocale.split('-')?.[1] || 'us').toUpperCase()

  if (currentIso2CountryCode === 'US') {
    return title
  }

  const currentCountryName = countries[currentIso2CountryCode] || ''

  return currentCountryName ? `${title} ${currentCountryName}` : title
}

// Builds the localized page title and og:title, appending the page number
// suffix for paginated routes.
export const getPageTitles = (
  initialState: State,
  title?: string,
  ogTitle?: string,
  page?: string | string[],
): PageTitles => {
  let pageTitle = title ? localizeTitle(title, initialState) : undefined
  let ogPageTitle = ogTitle ? localizeTitle(ogTitle, initialState) : undefined

  if (page) {
    if (pageTitle) pageTitle = pageTitle.concat(` | Page ${page}`)
    if (ogPageTitle) ogPageTitle = ogPageTitle.concat(` | Page ${page}`)
  }

  return { pageTitle, ogPageTitle }
}
